/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PermissionModel } from '../../models/permission-model';

export interface Save$Params {
      body?: PermissionModel
}

export function Save(http: HttpClient, rootUrl: string, params?: Save$Params, context?: HttpContext): Observable<StrictHttpResponse<PermissionModel>> {
  const rb = new RequestBuilder(rootUrl, Save.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PermissionModel>;
    })
  );
}

Save.PATH = '/api/Permissions/Save';
